/**
 * Site Navigation.
 *
 * @package
 * @since 1.0.0
 */

export const Nav = () => {
	const nullMenuLinks = document.querySelectorAll( '.menu-item a[href="#"]' );
	const siteNavigation = document.getElementById( 'header-primary-menu' );

	// Disable placeholder menu links.
	Array.from( nullMenuLinks ).forEach( ( nullLink ) => {
		nullLink.addEventListener( 'click', ( event ) => {
			event.preventDefault();
		} );
	} );

	// Expand navigation top level parent menu items on toggle click.
	if ( siteNavigation ) {
		siteNavigation.addEventListener(
			'click',
			function ( event ) {
				let menuToggleButton = event.target;

				while ( menuToggleButton ) {
					if (
						// The element clicked is a menu toggle button.
						menuToggleButton.nodeName === 'BUTTON' &&
						/js-menu-item-toggle/.test( menuToggleButton.className )
					) {
						// Toggle submenu open class.
						menuToggleButton.parentNode.classList.toggle( 'open' );

						// Toggle button [aria-expanded] values.
						if (
							menuToggleButton.getAttribute( 'aria-expanded' ) ===
							'true'
						) {
							menuToggleButton.setAttribute(
								'aria-expanded',
								'false'
							);
						} else {
							menuToggleButton.setAttribute(
								'aria-expanded',
								'true'
							);
						}
						break;
					}

					// Otherwise check the next parent node.
					menuToggleButton = menuToggleButton.parentNode;
				}
			},
			false
		);
	}
};
